import React from "react";
import SEO from "@/components/SEO";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import LogoMarquee from "@/components/landing/LogoMarquee";
import Features from "@/components/landing/Features";
import IntelligenceCore from "@/components/landing/IntelligenceCore";
import WhyClydeFlow from "@/components/landing/WhyClydeFlow";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

const FAQ_JSONLD = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "Is the DM Closer actually safe to use?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. ClydeFlow uses the official Meta Graph API — fully verified, fully approved.",
      },
    },
    {
      "@type": "Question",
      name: "How is this different from ChatGPT or generic AI tools?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Generic tools ideate. ClydeFlow executes — content goes live, DMs get sent, ads get synced.",
      },
    },
    {
      "@type": "Question",
      name: "What's the Mogul Growth Package about?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "A one-time £299 done-for-you onboarding. We install ClydeFlow across your business and train your team.",
      },
    },
  ],
};

const Landing = () => {
  return (
    <div className="min-h-screen bg-[#050B14] text-white" data-testid="landing-page">
      <SEO
        title="ClydeFlow — Automate your Empire. Own the Flow."
        description="The AI business automation suite that executes. Content Engine, Meta-verified DM Closer, Mogul Sync, and the ClydeFlow Assistant. Built in Glasgow."
        path="/"
        jsonLd={FAQ_JSONLD}
      />
      <Navbar />
      <main>
        <Hero />
        <LogoMarquee />
        <Features />
        <IntelligenceCore />
        <WhyClydeFlow />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Landing;
